<template>
    <div>
        <modal
                :width="500"
                height="auto"
                name="m-deletef"
                >
            <div class="modal-dialog abtg-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title abtg__modal-title" >{{ $t("mapping.folder_delete_title") }}</h5>

                        <div class="tools">
                            <div class="abtg__close-button"><a @click="closeModal()"><i
                                    class="fas fa-times"></i></a></div>
                        </div>
                    </div>

                        <div class="modal-body">
                          <h4>{{ $t("mapping.folder_delete_h3") }}</h4>
                          <h5>{{ $t("mapping.folder_delete_h5") }}</h5>
                        </div>
                        <div class="modal-footer">

                            <button
                                    @click="closeModal()"
                                    type="submit"
                                    class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool">
                              {{ $t("mapping.folder_delete_no") }}
                            </button>

                            <button
                                    @click="deleteFolder()"
                                    type="submit" class="btn btn-default  abtg__btn-third shadow-none abtg__btn-tool">
                              {{ $t("mapping.folder_delete_si") }}
                            </button>
                        </div>


                </div>
            </div>
        </modal>
    </div>

</template>
<script>
    export default {
        props: ['content'],
        data() {
            return {
            }
        },

        methods: {
            closeModal() {
                this.$emit('closeModal','m-deletef');
            },

            deleteFolder()
            {
                this.$emit('deleteFolder');
                this.closeModal();
            }
        }
    }
</script>